import {Model} from "./";
import {Api} from "../api";

class OcrAiSettingsModel extends Model {

    constructor() {
        super(new Api("/ocr-ai-settings"));
    }

    getAllSettings(thenFunction, errorFunction) {
        this.q.setDopUrl('/all');
        this.q.read({}, thenFunction, errorFunction);
    }

    createSettings(ob, thenFunction, errorFunction) {
        this.q.setDopUrl('/create');
        this.q.create(ob, thenFunction, errorFunction);
    }

    updateSettings(id, ob, thenFunction, errorFunction) {
        this.q.setDopUrl('/update/' + id);
        this.q.update(ob, thenFunction, errorFunction);
    }

    deleteSettings(id, thenFunction, errorFunction) {
        this.q.setDopUrl('/delete/' + id);
        this.q.delete({}, thenFunction, errorFunction);
    }

}

export default new OcrAiSettingsModel();
